module.exports = __webpack_public_path__ + "img/SM.eb894d9c.png";